export const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDMrf4niW-Vt0aSliOJ-cJ-A0j7zNfeKDk",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "eventnova-d4f1a.firebaseapp.com",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || "eventnova-d4f1a",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "eventnova-d4f1a.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "835659841246",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:835659841246:web:44aaaa518f19025a0bcc4f",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-ZREWLVEDFL",
};

export const firebaseVapidKey =
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  "BAAkbtT9JFMEy16wlEU4JORgZ7oMsVszwHJvTtrwF8MJPj-kyeKMx5KexybOD2ctW-u0_akRcC5DB871vKX_tlQ";

